import React, { useCallback } from 'react';
import { useSnapshot } from 'valtio';

import '../../www/assets/css/modal.css';
import { modalStore, refsStore } from '../managers/globalState';
import ar from '../languages/ar';

const Modal = () => {
	const { isVisible, startRange, endRange, numMissingDatasets, onClose } = useSnapshot(modalStore.state);
	const { get } = useSnapshot(refsStore.state);
	const { isMonthly } = get('dataset');

	const modalDateOptions = {
		month: 'short',
		year: 'numeric',
		...!isMonthly && { day: 'numeric' }
	};

	const start = typeof startRange === 'string' ? startRange : startRange?.toLocaleDateString(undefined, modalDateOptions);
	const end = typeof endRange === 'string' ? endRange : endRange?.toLocaleDateString(undefined, modalDateOptions);
	const message = numMissingDatasets ?
		`هنالك ${numMissingDatasets === 1 ? 'مجموعة واحدة من البيانات مفقودة' : numMissingDatasets === 2 ? 'مجموعتين من البيانات المفقودة' : ` ${numMissingDatasets} مجموعات من البيانات مفقودة`} 
		خلال المدة الزمنية الموضحة أدناه:` :
		'لا توجد مجموعات بيانات متاحة خلال المدة المحددة';

	const dismissModal = useCallback(() => {
		typeof onClose === 'function' && onClose();
		modalStore.setGlobalState({
			isVisible: false,
			startRange: null,
			endRange: null,
			numMissingDatasets: null,
			onClose: null
		});
	}, [onClose]);

	return isVisible ?
		(
			<div className='modal-container' role='dialog' aria-hidden='true' onClick={dismissModal}>
				<div className='modal-dialog modal-dialog-centered' role='document'>
					<div className='modal-content'>
						<h2>{ar.Dataset_Information}</h2>
						<div className='modal-body'>
							<p className='modal-text'>{message}</p>
							<p className='modal-text'>
								{start}
								{' '}
								to
								{' '}
								{end}
							</p>
							{numMissingDatasets > 0 && <p className='modal-text'> ستتخطى الرسوم المتحركة تلك الفترة المفقودة تلقائياً</p>}
						</div>
						<div className='modal-footer d-flex justify-content-center'>
							<button type='button' className='btn ok-button' onClick={dismissModal}>{ar.ok}</button>
						</div>
					</div>
				</div>
			</div>
		)
		: null;
};

export default Modal;
